<script lang="ts">import { getTracking } from '../../../../js-v2/tracking';
import { trackLinkClick } from '../../../../js-v2/trackLinkClick';
import LinkText from './Link--text.svelte';
import LinkButton from './Link--button.svelte';
const { id = '', title = '', url = '#', icon = undefined, linkStyle = 'text', linkCustomCssClass = undefined, enableHoverOpacity = false, openInNewTab = false, hoverWithDelayConfig = undefined, } = $props();
const trackFn = getTracking();
</script>

<div class="Link" use:trackLinkClick={{ id, title, url, trackFn }}>
  {#if linkStyle === 'primary' || linkStyle === 'secondary'}
    <LinkButton {linkCustomCssClass} {id} {title} {url} {linkStyle} svgIcon={icon?.svgString} {openInNewTab} />
  {:else}
    <LinkText
      {linkCustomCssClass}
      {id}
      {title}
      {url}
      svgIcon={icon?.svgString}
      {enableHoverOpacity}
      {openInNewTab}
      {hoverWithDelayConfig}
    />
  {/if}
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Link {
  text-align: initial;
}</style>
